var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _g, _path104, _path105, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoulVertBetarea1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 690,
    viewBox: "0 0 742 1501",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M609.449 41.0672L371.646 3.18182L133.842 41.0672V107.207H609.449V41.0672Z",
    fill: "#009003",
    fillOpacity: 0.7,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.89 41.0672L371.087 3.18182L133.283 41.0672V107.207H608.89V41.0672Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.75 107.909H134.215V214.836H292.75V107.909Z",
    fill: "#F40906",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.818 107.206H133.283V214.133H291.818V107.206Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.59 107.748H292.055V214.675H450.59V107.748Z",
    fill: "black",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.354 107.206H291.818V214.133H450.354V107.206Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.803 107.748H450.267V214.675H608.803V107.748Z",
    fill: "#F40906",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.889 107.206H450.354V214.133H608.889V107.206Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.818 214.134H133.283V321.061H291.818V214.134Z",
    fill: "black",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.818 214.134H133.283V321.061H291.818V214.134Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.354 214.134H291.818V321.061H450.354V214.134Z",
    fill: "#F40906",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.354 214.134H291.818V321.061H450.354V214.134Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.89 214.134H450.354V321.061H608.89V214.134Z",
    fill: "black",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.89 214.134H450.354V321.061H608.89V214.134Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.819 321.061H133.283V427.988H291.819V321.061Z",
    fill: "#F40906",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.819 321.061H133.283V427.988H291.819V321.061Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.354 321.061H291.818V427.988H450.354V321.061Z",
    fill: "black",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.354 321.061H291.818V427.988H450.354V321.061Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.89 321.061H450.354V427.988H608.89V321.061Z",
    fill: "#F40906",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.89 321.061H450.354V427.988H608.89V321.061Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.819 427.989H133.283V534.916H291.819V427.989Z",
    fill: "black",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.819 427.989H133.283V534.916H291.819V427.989Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.354 427.989H291.818V534.916H450.354V427.989Z",
    fill: "black",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.354 427.989H291.818V534.916H450.354V427.989Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.89 427.989H450.354V534.916H608.89V427.989Z",
    fill: "#F40906",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.89 427.989H450.354V534.916H608.89V427.989Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.819 534.916H133.283V641.843H291.819V534.916Z",
    fill: "black",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.819 534.916H133.283V641.843H291.819V534.916Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.354 534.916H291.818V641.843H450.354V534.916Z",
    fill: "#F40906",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.354 534.916H291.818V641.843H450.354V534.916Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.89 534.916H450.354V641.843H608.89V534.916Z",
    fill: "black",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.89 534.916H450.354V641.843H608.89V534.916Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.819 641.844H133.283V748.771H291.819V641.844Z",
    fill: "#F40906",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.819 641.844H133.283V748.771H291.819V641.844Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.354 641.844H291.818V748.771H450.354V641.844Z",
    fill: "black",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.354 641.844H291.818V748.771H450.354V641.844Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.89 641.844H450.354V748.771H608.89V641.844Z",
    fill: "#F40906",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.89 641.844H450.354V748.771H608.89V641.844Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.819 748.771H133.283V855.698H291.819V748.771Z",
    fill: "#F40906",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.819 748.771H133.283V855.698H291.819V748.771Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.354 748.771H291.818V855.698H450.354V748.771Z",
    fill: "black",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.354 748.771H291.818V855.698H450.354V748.771Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.89 748.771H450.354V855.698H608.89V748.771Z",
    fill: "#F40906",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.89 748.771H450.354V855.698H608.89V748.771Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.819 855.699H133.283V962.626H291.819V855.699Z",
    fill: "black",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.819 855.699H133.283V962.626H291.819V855.699Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.354 855.698H291.818V962.626H450.354V855.698Z",
    fill: "#F40906",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.354 855.698H291.818V962.626H450.354V855.698Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.89 855.698H450.354V962.626H608.89V855.698Z",
    fill: "black",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.89 855.698H450.354V962.626H608.89V855.698Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.819 962.626H133.283V1069.55H291.819V962.626Z",
    fill: "#F40906",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.819 962.626H133.283V1069.55H291.819V962.626Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.354 962.626H291.818V1069.55H450.354V962.626Z",
    fill: "black",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.354 962.626H291.818V1069.55H450.354V962.626Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.89 962.626H450.354V1069.55H608.89V962.626Z",
    fill: "#F40906",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.89 962.626H450.354V1069.55H608.89V962.626Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.819 1069.55H133.283V1176.48H291.819V1069.55Z",
    fill: "black",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.819 1069.55H133.283V1176.48H291.819V1069.55Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.354 1069.55H291.818V1176.48H450.354V1069.55Z",
    fill: "black",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.354 1069.55H291.818V1176.48H450.354V1069.55Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.89 1069.55H450.354V1176.48H608.89V1069.55Z",
    fill: "#F40906",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.89 1069.55H450.354V1176.48H608.89V1069.55Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.819 1176.48H133.283V1283.41H291.819V1176.48Z",
    fill: "black",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.819 1176.48H133.283V1283.41H291.819V1176.48Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.354 1176.48H291.818V1283.41H450.354V1176.48Z",
    fill: "#F40906",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.354 1176.48H291.818V1283.41H450.354V1176.48Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.89 1176.48H450.354V1283.41H608.89V1176.48Z",
    fill: "black",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.89 1176.48H450.354V1283.41H608.89V1176.48Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.377 1283.41H133.842V1390.34H292.377V1283.41Z",
    fill: "#F40906",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.819 1283.41H133.283V1390.34H291.819V1283.41Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.59 1283.41H292.055V1390.34H450.59V1283.41Z",
    fill: "black",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.354 1283.41H291.818V1390.34H450.354V1283.41Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.803 1283.41H450.267V1390.34H608.803V1283.41Z",
    fill: "#F40906",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.89 1283.41H450.354V1390.34H608.89V1283.41Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.18262 535.462H133.124V107.909H2.18262V535.462Z",
    fill: "#02401D",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.18262 963.099H133.124V535.545H2.18262V963.099Z",
    fill: "#02401D",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.18262 1390.74H133.124V963.182H2.18262V1390.74Z",
    fill: "#02401D",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.18262 962.783H133.124V535.23H2.18262V962.783Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.18262 1390.34H133.124V962.783H2.18262V1390.34Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.18262 535.23H133.124V107.677H2.18262V535.23Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.215 1497.75H292.75V1390.82H134.215V1497.75Z",
    fill: "#02401D",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.283 1497.26H291.818V1390.34H133.283V1497.26Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.436 1497.75H450.971V1390.82H292.436V1497.75Z",
    fill: "#02401D",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.819 1497.26H450.355V1390.34H291.819V1497.26Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.656 1497.75H609.192V1390.82H450.656V1497.75Z",
    fill: "#02401D",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.355 1497.26H608.891V1390.34H450.355V1497.26Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.877 321.686H739.818V107.909H608.877V321.686Z",
    fill: "#02401D",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.877 321.686H739.818V107.909H608.877V321.686Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.877 534.413H739.818V320.636H608.877V534.413Z",
    fill: "#02401D",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.877 535.504H739.818V321.727H608.877V535.504Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.877 749.322H739.818V535.545H608.877V749.322Z",
    fill: "#02401D",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.877 749.322H739.818V535.545H608.877V749.322Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.877 963.14H739.818V749.364H608.877V963.14Z",
    fill: "#02401D",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.877 963.14H739.818V749.364H608.877V963.14Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.877 1176.96H739.818V963.182H608.877V1176.96Z",
    fill: "#02401D",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.877 1176.96H739.818V963.182H608.877V1176.96Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.877 1389.69H739.818V1175.91H608.877V1389.69Z",
    fill: "#02401D",
    fillOpacity: 0.8,
    stroke: "#979797",
    strokeWidth: 1.09091
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.877 1389.69H739.818V1175.91H608.877V1389.69Z",
    stroke: "#808080",
    strokeWidth: 4.36364
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M674.685 663.711C674.475 663.711 674.265 663.657 674.072 663.551L637.919 643.57C637.479 643.326 637.202 642.842 637.202 642.315C637.202 641.788 637.479 641.304 637.919 641.061L674.072 621.079C674.265 620.972 674.475 620.92 674.685 620.92C674.895 620.92 675.105 620.972 675.298 621.079L711.452 641.061C711.892 641.304 712.168 641.788 712.168 642.315C712.168 642.842 711.892 643.326 711.452 643.57L675.298 663.551C675.105 663.657 674.895 663.711 674.685 663.711Z",
    fill: "#F40906"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M674.685 877.53C674.475 877.53 674.265 877.476 674.072 877.37L637.919 857.388C637.479 857.145 637.202 856.66 637.202 856.133C637.202 855.606 637.479 855.123 637.919 854.88L674.072 834.898C674.265 834.79 674.475 834.738 674.685 834.738C674.895 834.738 675.105 834.79 675.298 834.898L711.452 854.88C711.892 855.123 712.168 855.606 712.168 856.133C712.168 856.66 711.892 857.145 711.452 857.388L675.298 877.37C675.105 877.476 674.895 877.53 674.685 877.53Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M673.833 833.647C673.412 833.647 672.991 833.753 672.606 833.966L636.453 853.948C635.573 854.434 635.02 855.402 635.02 856.456C635.02 857.511 635.573 858.477 636.453 858.963L672.606 878.947C672.991 879.159 673.412 879.265 673.833 879.265C674.255 879.265 674.676 879.159 675.061 878.947L711.214 858.963C712.094 858.477 712.646 857.511 712.646 856.456C712.646 855.402 712.094 854.434 711.214 853.948L675.061 833.966C674.676 833.753 674.255 833.647 673.833 833.647ZM673.834 836.473L709.987 856.457L673.834 876.439L637.679 856.457L673.834 836.473Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M673.833 619.829C673.412 619.829 672.991 619.935 672.606 620.148L636.453 640.13C635.573 640.616 635.02 641.584 635.02 642.638C635.02 643.693 635.573 644.659 636.453 645.145L672.606 665.129C672.991 665.34 673.412 665.446 673.833 665.446C674.255 665.446 674.676 665.34 675.061 665.129L711.214 645.145C712.094 644.659 712.646 643.693 712.646 642.638C712.646 641.584 712.094 640.616 711.214 640.13L675.061 620.148C674.676 619.935 674.255 619.829 673.833 619.829ZM673.834 622.655L709.987 642.638L673.834 662.62L637.679 642.638L673.834 622.655Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M369.832 76.8507C363.723 76.8507 359.839 71.3088 359.839 60.1816C359.839 49.0543 363.723 43.687 369.832 43.687C375.897 43.687 379.781 49.0979 379.781 60.1816C379.781 71.3088 375.897 76.8507 369.832 76.8507ZM369.832 73.6652C373.453 73.6652 375.897 69.607 375.897 60.1816C375.897 50.8434 373.453 46.9161 369.832 46.9161C366.166 46.9161 363.723 50.8434 363.723 60.1816C363.723 69.607 366.166 73.6652 369.832 73.6652Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_334_179414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.283 182.369V179.052H210.396V155.183H204.723V152.652C207.56 152.129 209.611 151.387 211.356 150.383H214.411V179.052H220.825V182.369H203.283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.545 182.369V180.012C369.581 171.241 374.207 164.87 374.207 159.372C374.207 155.707 372.287 153.045 368.316 153.045C365.698 153.045 363.429 154.659 361.683 156.754L359.37 154.485C361.989 151.649 364.738 149.772 368.796 149.772C374.512 149.772 378.09 153.525 378.09 159.241C378.09 165.612 373.072 172.114 365.567 179.227C367.225 179.096 369.189 178.921 370.803 178.921H379.661V182.369H359.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.327 182.936C522.309 182.936 519.167 180.841 517.072 178.572L519.08 175.954C520.956 177.918 523.4 179.62 527.022 179.62C530.818 179.62 533.523 177.35 533.523 173.685C533.523 169.845 530.949 167.27 523.574 167.27V164.216C530.163 164.216 532.432 161.554 532.432 158.107C532.432 155.009 530.338 153.045 527.022 152.958C524.447 153.045 522.178 154.354 520.389 156.143L518.251 153.612C520.651 151.387 523.487 149.772 527.196 149.772C532.563 149.772 536.491 152.652 536.491 157.801C536.491 161.685 534.178 164.259 530.774 165.525V165.699C534.571 166.572 537.582 169.452 537.582 173.816C537.582 179.532 533 182.936 527.327 182.936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.461 277.278H214.236V267.459C214.236 265.889 214.411 263.314 214.498 261.656H214.323C213.538 263.227 212.665 264.798 211.749 266.369L204.461 277.278ZM222.265 277.278V280.463H218.032V289.278H214.236V280.463H200.316V277.845L213.625 257.292H218.032V277.278H222.265Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.014 289.845C364.039 289.845 360.985 287.75 358.847 285.612L360.81 282.994C362.643 284.827 364.956 286.529 368.665 286.529C372.418 286.529 375.472 283.649 375.472 278.979C375.472 274.398 372.854 271.692 368.839 271.692C366.701 271.692 365.349 272.347 363.516 273.569L361.378 272.259L362.381 257.292H377.959V260.696H365.872L365.087 269.947C366.483 269.161 367.923 268.681 369.843 268.681C375.167 268.681 379.487 271.823 379.487 278.849C379.487 285.874 374.425 289.845 369.014 289.845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.942 286.747C531.996 286.747 534.352 283.823 534.352 279.459C534.352 275.139 532.476 272.39 528.592 272.39C526.585 272.39 524.142 273.525 522.047 276.492C522.527 283.125 524.927 286.747 528.942 286.747ZM537.538 259.954L535.356 262.441C534.091 260.914 532.171 259.998 530.207 259.998C525.843 259.998 522.134 263.358 521.96 273.307C523.923 270.907 526.716 269.423 529.247 269.423C534.658 269.423 538.105 272.783 538.105 279.459C538.105 285.656 533.916 289.845 528.942 289.845C522.789 289.845 518.251 284.565 518.251 274.005C518.251 261.481 523.88 256.681 530.076 256.681C533.392 256.681 535.792 258.078 537.538 259.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.083 396.187C208.607 384.056 210.832 376.332 217.072 367.605H201.581V364.201H221.611V366.601C214.105 376.245 212.709 383.663 212.229 396.187H208.083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.799 396.754C363.909 396.754 359.589 393.176 359.589 388.245C359.589 383.969 362.556 381.001 365.479 379.43V379.212C363.123 377.598 361.159 375.198 361.159 371.838C361.159 366.95 364.912 363.721 369.93 363.721C375.385 363.721 378.701 367.212 378.701 372.143C378.701 375.503 376.345 378.383 374.425 379.867V380.085C377.218 381.699 379.836 384.099 379.836 388.463C379.836 393.132 375.821 396.754 369.799 396.754ZM371.981 378.819C374.163 376.899 375.298 374.718 375.298 372.361C375.298 369.219 373.29 366.645 369.843 366.645C366.919 366.645 364.781 368.739 364.781 371.838C364.781 375.678 368.229 377.336 371.981 378.819ZM369.887 393.787C373.552 393.787 376.039 391.561 376.039 388.376C376.039 384.099 372.112 382.485 367.574 380.652C364.999 382.31 363.21 384.841 363.21 387.896C363.21 391.299 366.047 393.787 369.887 393.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.196 381.089C529.334 381.089 531.734 379.867 533.872 376.812C533.436 370.223 530.992 366.732 526.891 366.732C523.836 366.732 521.48 369.612 521.48 373.976C521.48 378.296 523.4 381.089 527.196 381.089ZM518.338 393.481L520.52 390.994C521.872 392.521 523.836 393.438 525.887 393.438C530.032 393.438 533.611 390.034 533.916 380.085C531.996 382.485 529.247 384.056 526.542 384.056C521.218 384.056 517.727 380.609 517.727 373.976C517.727 367.779 521.916 363.59 526.891 363.59C533.043 363.59 537.625 368.652 537.625 378.819C537.625 391.779 532.04 396.754 526.018 396.754C522.571 396.754 520.127 395.358 518.338 393.481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.181 503.096V499.779H198.294V475.91H192.621V473.379C195.457 472.856 197.508 472.114 199.254 471.11H202.308V499.779H208.723V503.096H191.181ZM223.676 503.663C217.567 503.663 213.684 498.121 213.684 486.994C213.684 475.867 217.567 470.499 223.676 470.499C229.742 470.499 233.626 475.91 233.626 486.994C233.626 498.121 229.742 503.663 223.676 503.663ZM223.676 500.478C227.298 500.478 229.742 496.419 229.742 486.994C229.742 477.656 227.298 473.729 223.676 473.729C220.011 473.729 217.567 477.656 217.567 486.994C217.567 496.419 220.011 500.478 223.676 500.478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.363 503.096V499.779H356.475V475.91H350.803V473.379C353.639 472.856 355.69 472.114 357.435 471.11H360.49V499.779H366.904V503.096H349.363ZM373.567 503.096V499.779H380.68V475.91H375.007V473.379C377.844 472.856 379.894 472.114 381.64 471.11H384.694V499.779H391.109V503.096H373.567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.545 503.096V499.779H514.657V475.91H508.985V473.379C511.821 472.856 513.872 472.114 515.617 471.11H518.672V499.779H525.087V503.096H507.545ZM529.829 503.096V500.739C539.866 491.969 544.491 485.598 544.491 480.099C544.491 476.434 542.571 473.772 538.6 473.772C535.982 473.772 533.713 475.387 531.967 477.481L529.655 475.212C532.273 472.376 535.022 470.499 539.08 470.499C544.797 470.499 548.375 474.252 548.375 479.969C548.375 486.339 543.357 492.841 535.851 499.954C537.509 499.823 539.473 499.649 541.087 499.649H549.946V503.096H529.829Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.181 610.005V606.689H198.294V582.819H192.621V580.289C195.457 579.765 197.508 579.023 199.254 578.019H202.308V606.689H208.723V610.005H191.181ZM223.066 610.572C218.047 610.572 214.906 608.478 212.811 606.209L214.818 603.59C216.695 605.554 219.138 607.256 222.76 607.256C226.556 607.256 229.262 604.987 229.262 601.321C229.262 597.481 226.687 594.907 219.313 594.907V591.852C225.902 591.852 228.171 589.19 228.171 585.743C228.171 582.645 226.076 580.681 222.76 580.594C220.186 580.681 217.916 581.99 216.127 583.779L213.989 581.249C216.389 579.023 219.226 577.409 222.935 577.409C228.302 577.409 232.229 580.289 232.229 585.438C232.229 589.321 229.916 591.896 226.513 593.161V593.336C230.309 594.209 233.32 597.089 233.32 601.452C233.32 607.169 228.738 610.572 223.066 610.572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.363 610.005V606.689H356.475V582.819H350.803V580.289C353.639 579.765 355.69 579.023 357.435 578.019H360.49V606.689H366.904V610.005H349.363ZM374.745 598.005H384.52V588.187C384.52 586.616 384.694 584.041 384.782 582.383H384.607C383.822 583.954 382.949 585.525 382.033 587.096L374.745 598.005ZM392.549 598.005V601.19H388.316V610.005H384.52V601.19H370.6V598.572L383.909 578.019H388.316V598.005H392.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.545 610.005V606.689H514.657V582.819H508.985V580.289C511.821 579.765 513.872 579.023 515.617 578.019H518.672V606.689H525.087V610.005H507.545ZM539.298 610.572C534.324 610.572 531.269 608.478 529.131 606.339L531.095 603.721C532.927 605.554 535.24 607.256 538.949 607.256C542.702 607.256 545.757 604.376 545.757 599.707C545.757 595.125 543.138 592.419 539.124 592.419C536.986 592.419 535.633 593.074 533.8 594.296L531.662 592.987L532.666 578.019H548.244V581.423H536.157L535.371 590.674C536.767 589.889 538.207 589.409 540.127 589.409C545.451 589.409 549.771 592.55 549.771 599.576C549.771 606.601 544.709 610.572 539.298 610.572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.181 716.914V713.598H198.294V689.729H192.621V687.198C195.457 686.674 197.508 685.932 199.254 684.929H202.308V713.598H208.723V716.914H191.181ZM224.68 714.383C227.735 714.383 230.091 711.46 230.091 707.096C230.091 702.776 228.215 700.027 224.331 700.027C222.324 700.027 219.88 701.161 217.786 704.129C218.266 710.761 220.666 714.383 224.68 714.383ZM233.276 687.59L231.095 690.078C229.829 688.55 227.909 687.634 225.946 687.634C221.582 687.634 217.873 690.994 217.698 700.943C219.662 698.543 222.455 697.06 224.986 697.06C230.396 697.06 233.844 700.42 233.844 707.096C233.844 713.292 229.655 717.481 224.68 717.481C218.527 717.481 213.989 712.201 213.989 701.641C213.989 689.118 219.618 684.318 225.815 684.318C229.131 684.318 231.531 685.714 233.276 687.59Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.363 716.914V713.598H356.475V689.729H350.803V687.198C353.639 686.674 355.69 685.932 357.435 684.929H360.49V713.598H366.904V716.914H349.363ZM378.367 716.914C378.891 704.783 381.116 697.06 387.356 688.332H371.865V684.929H391.894V687.329C384.389 696.972 382.993 704.39 382.513 716.914H378.367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.545 716.914V713.598H514.657V689.729H508.985V687.198C511.821 686.674 513.872 685.932 515.617 684.929H518.672V713.598H525.087V716.914H507.545ZM540.084 717.481C534.193 717.481 529.873 713.903 529.873 708.972C529.873 704.696 532.84 701.729 535.764 700.158V699.94C533.407 698.325 531.444 695.925 531.444 692.565C531.444 687.678 535.197 684.449 540.215 684.449C545.669 684.449 548.986 687.94 548.986 692.87C548.986 696.23 546.629 699.11 544.709 700.594V700.812C547.502 702.427 550.12 704.827 550.12 709.19C550.12 713.86 546.106 717.481 540.084 717.481ZM542.266 699.547C544.447 697.627 545.582 695.445 545.582 693.089C545.582 689.947 543.575 687.372 540.127 687.372C537.204 687.372 535.066 689.467 535.066 692.565C535.066 696.405 538.513 698.063 542.266 699.547ZM540.171 714.514C543.837 714.514 546.324 712.289 546.324 709.103C546.324 704.827 542.397 703.212 537.858 701.38C535.284 703.038 533.495 705.569 533.495 708.623C533.495 712.027 536.331 714.514 540.171 714.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.181 823.823V820.507H198.294V796.638H192.621V794.107C195.457 793.583 197.508 792.841 199.254 791.838H202.308V820.507H208.723V823.823H191.181ZM222.935 808.725C225.073 808.725 227.473 807.503 229.611 804.449C229.175 797.86 226.731 794.369 222.629 794.369C219.575 794.369 217.218 797.249 217.218 801.612C217.218 805.932 219.138 808.725 222.935 808.725ZM214.076 821.118L216.258 818.631C217.611 820.158 219.575 821.074 221.626 821.074C225.771 821.074 229.349 817.671 229.655 807.721C227.735 810.121 224.986 811.692 222.28 811.692C216.956 811.692 213.466 808.245 213.466 801.612C213.466 795.416 217.655 791.227 222.629 791.227C228.782 791.227 233.364 796.289 233.364 806.456C233.364 819.416 227.778 824.391 221.756 824.391C218.309 824.391 215.866 822.994 214.076 821.118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.443 823.823V821.467C357.479 812.696 362.104 806.325 362.104 800.827C362.104 797.161 360.184 794.5 356.214 794.5C353.595 794.5 351.326 796.114 349.581 798.209L347.268 795.94C349.886 793.103 352.635 791.227 356.694 791.227C362.41 791.227 365.988 794.98 365.988 800.696C365.988 807.067 360.97 813.569 353.464 820.681C355.123 820.551 357.086 820.376 358.701 820.376H367.559V823.823H347.443ZM381.858 824.391C375.749 824.391 371.865 818.849 371.865 807.721C371.865 796.594 375.749 791.227 381.858 791.227C387.924 791.227 391.807 796.638 391.807 807.721C391.807 818.849 387.924 824.391 381.858 824.391ZM381.858 821.205C385.48 821.205 387.924 817.147 387.924 807.721C387.924 798.383 385.48 794.456 381.858 794.456C378.193 794.456 375.749 798.383 375.749 807.721C375.749 817.147 378.193 821.205 381.858 821.205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.625 823.823V821.467C515.661 812.696 520.287 806.325 520.287 800.827C520.287 797.161 518.367 794.5 514.396 794.5C511.777 794.5 509.508 796.114 507.763 798.209L505.45 795.94C508.068 793.103 510.817 791.227 514.876 791.227C520.592 791.227 524.17 794.98 524.17 800.696C524.17 807.067 519.152 813.569 511.647 820.681C513.305 820.551 515.268 820.376 516.883 820.376H525.741V823.823H505.625ZM531.749 823.823V820.507H538.862V796.638H533.189V794.107C536.026 793.583 538.077 792.841 539.822 791.838H542.877V820.507H549.291V823.823H531.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.261 930.732V928.376C199.297 919.605 203.923 913.234 203.923 907.736C203.923 904.07 202.003 901.409 198.032 901.409C195.414 901.409 193.145 903.023 191.399 905.118L189.086 902.849C191.705 900.012 194.454 898.136 198.512 898.136C204.228 898.136 207.806 901.889 207.806 907.605C207.806 913.976 202.788 920.478 195.283 927.59C196.941 927.46 198.905 927.285 200.519 927.285H209.377V930.732H189.261ZM213.466 930.732V928.376C223.502 919.605 228.127 913.234 228.127 907.736C228.127 904.07 226.207 901.409 222.236 901.409C219.618 901.409 217.349 903.023 215.604 905.118L213.291 902.849C215.909 900.012 218.658 898.136 222.716 898.136C228.433 898.136 232.011 901.889 232.011 907.605C232.011 913.976 226.993 920.478 219.487 927.59C221.146 927.46 223.109 927.285 224.724 927.285H233.582V930.732H213.466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.443 930.732V928.376C357.479 919.605 362.104 913.234 362.104 907.736C362.104 904.07 360.184 901.409 356.214 901.409C353.595 901.409 351.326 903.023 349.581 905.118L347.268 902.849C349.886 900.012 352.635 898.136 356.694 898.136C362.41 898.136 365.988 901.889 365.988 907.605C365.988 913.976 360.97 920.478 353.464 927.59C355.123 927.46 357.086 927.285 358.701 927.285H367.559V930.732H347.443ZM381.247 931.3C376.229 931.3 373.087 929.205 370.993 926.936L373 924.318C374.876 926.281 377.32 927.983 380.942 927.983C384.738 927.983 387.444 925.714 387.444 922.049C387.444 918.209 384.869 915.634 377.494 915.634V912.58C384.084 912.58 386.353 909.918 386.353 906.47C386.353 903.372 384.258 901.409 380.942 901.321C378.367 901.409 376.098 902.718 374.309 904.507L372.171 901.976C374.571 899.75 377.407 898.136 381.116 898.136C386.484 898.136 390.411 901.016 390.411 906.165C390.411 910.049 388.098 912.623 384.694 913.889V914.063C388.491 914.936 391.502 917.816 391.502 922.18C391.502 927.896 386.92 931.3 381.247 931.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.625 930.732V928.376C515.661 919.605 520.287 913.234 520.287 907.736C520.287 904.07 518.367 901.409 514.396 901.409C511.777 901.409 509.508 903.023 507.763 905.118L505.45 902.849C508.068 900.012 510.817 898.136 514.876 898.136C520.592 898.136 524.17 901.889 524.17 907.605C524.17 913.976 519.152 920.478 511.647 927.59C513.305 927.46 515.268 927.285 516.883 927.285H525.741V930.732H505.625ZM532.927 918.732H542.702V908.914C542.702 907.343 542.877 904.769 542.964 903.11H542.789C542.004 904.681 541.131 906.252 540.215 907.823L532.927 918.732ZM550.731 918.732V921.918H546.498V930.732H542.702V921.918H528.782V919.3L542.091 898.747H546.498V918.732H550.731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.261 1037.64V1035.28C199.297 1026.51 203.923 1020.14 203.923 1014.64C203.923 1010.98 202.003 1008.32 198.032 1008.32C195.414 1008.32 193.145 1009.93 191.399 1012.03L189.086 1009.76C191.705 1006.92 194.454 1005.04 198.512 1005.04C204.228 1005.04 207.806 1008.8 207.806 1014.51C207.806 1020.88 202.788 1027.39 195.283 1034.5C196.941 1034.37 198.905 1034.19 200.519 1034.19H209.377V1037.64H189.261ZM222.935 1038.21C217.96 1038.21 214.906 1036.11 212.767 1033.98L214.731 1031.36C216.564 1033.19 218.876 1034.89 222.586 1034.89C226.338 1034.89 229.393 1032.01 229.393 1027.34C229.393 1022.76 226.775 1020.06 222.76 1020.06C220.622 1020.06 219.269 1020.71 217.436 1021.93L215.298 1020.62L216.302 1005.66H231.88V1009.06H219.793L219.007 1018.31C220.404 1017.52 221.844 1017.04 223.764 1017.04C229.087 1017.04 233.407 1020.19 233.407 1027.21C233.407 1034.24 228.346 1038.21 222.935 1038.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.443 1037.64V1035.28C357.479 1026.51 362.104 1020.14 362.104 1014.64C362.104 1010.98 360.184 1008.32 356.214 1008.32C353.595 1008.32 351.326 1009.93 349.581 1012.03L347.268 1009.76C349.886 1006.92 352.635 1005.04 356.694 1005.04C362.41 1005.04 365.988 1008.8 365.988 1014.51C365.988 1020.88 360.97 1027.39 353.464 1034.5C355.123 1034.37 357.086 1034.19 358.701 1034.19H367.559V1037.64H347.443ZM382.862 1035.11C385.916 1035.11 388.273 1032.19 388.273 1027.82C388.273 1023.5 386.396 1020.75 382.513 1020.75C380.505 1020.75 378.062 1021.89 375.967 1024.86C376.447 1031.49 378.847 1035.11 382.862 1035.11ZM391.458 1008.32L389.276 1010.8C388.011 1009.28 386.091 1008.36 384.127 1008.36C379.764 1008.36 376.054 1011.72 375.88 1021.67C377.844 1019.27 380.636 1017.79 383.167 1017.79C388.578 1017.79 392.025 1021.15 392.025 1027.82C392.025 1034.02 387.836 1038.21 382.862 1038.21C376.709 1038.21 372.171 1032.93 372.171 1022.37C372.171 1009.84 377.8 1005.04 383.996 1005.04C387.313 1005.04 389.713 1006.44 391.458 1008.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.625 1037.64V1035.28C515.661 1026.51 520.287 1020.14 520.287 1014.64C520.287 1010.98 518.367 1008.32 514.396 1008.32C511.777 1008.32 509.508 1009.93 507.763 1012.03L505.45 1009.76C508.068 1006.92 510.817 1005.04 514.876 1005.04C520.592 1005.04 524.17 1008.8 524.17 1014.51C524.17 1020.88 519.152 1027.39 511.647 1034.5C513.305 1034.37 515.268 1034.19 516.883 1034.19H525.741V1037.64H505.625ZM536.549 1037.64C537.073 1025.51 539.298 1017.79 545.538 1009.06H530.047V1005.66H550.077V1008.06C542.571 1017.7 541.175 1025.12 540.695 1037.64H536.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.261 1144.55V1142.19C199.297 1133.42 203.923 1127.05 203.923 1121.55C203.923 1117.89 202.003 1115.23 198.032 1115.23C195.414 1115.23 193.145 1116.84 191.399 1118.94L189.086 1116.67C191.705 1113.83 194.454 1111.95 198.512 1111.95C204.228 1111.95 207.806 1115.71 207.806 1121.42C207.806 1127.79 202.788 1134.3 195.283 1141.41C196.941 1141.28 198.905 1141.1 200.519 1141.1H209.377V1144.55H189.261ZM223.72 1145.12C217.829 1145.12 213.509 1141.54 213.509 1136.61C213.509 1132.33 216.476 1129.37 219.4 1127.79V1127.58C217.044 1125.96 215.08 1123.56 215.08 1120.2C215.08 1115.31 218.833 1112.09 223.851 1112.09C229.306 1112.09 232.622 1115.58 232.622 1120.51C232.622 1123.87 230.266 1126.75 228.346 1128.23V1128.45C231.138 1130.06 233.756 1132.46 233.756 1136.83C233.756 1141.5 229.742 1145.12 223.72 1145.12ZM225.902 1127.18C228.084 1125.26 229.218 1123.08 229.218 1120.73C229.218 1117.58 227.211 1115.01 223.764 1115.01C220.84 1115.01 218.702 1117.1 218.702 1120.2C218.702 1124.04 222.149 1125.7 225.902 1127.18ZM223.807 1142.15C227.473 1142.15 229.96 1139.93 229.96 1136.74C229.96 1132.46 226.033 1130.85 221.495 1129.02C218.92 1130.67 217.131 1133.21 217.131 1136.26C217.131 1139.66 219.967 1142.15 223.807 1142.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.443 1144.55V1142.19C357.479 1133.42 362.104 1127.05 362.104 1121.55C362.104 1117.89 360.184 1115.23 356.214 1115.23C353.595 1115.23 351.326 1116.84 349.581 1118.94L347.268 1116.67C349.886 1113.83 352.635 1111.95 356.694 1111.95C362.41 1111.95 365.988 1115.71 365.988 1121.42C365.988 1127.79 360.97 1134.3 353.464 1141.41C355.123 1141.28 357.086 1141.1 358.701 1141.1H367.559V1144.55H347.443ZM381.116 1129.45C383.254 1129.45 385.654 1128.23 387.793 1125.18C387.356 1118.59 384.913 1115.1 380.811 1115.1C377.756 1115.1 375.4 1117.98 375.4 1122.34C375.4 1126.66 377.32 1129.45 381.116 1129.45ZM372.258 1141.85L374.44 1139.36C375.793 1140.89 377.756 1141.8 379.807 1141.8C383.953 1141.8 387.531 1138.4 387.836 1128.45C385.916 1130.85 383.167 1132.42 380.462 1132.42C375.138 1132.42 371.647 1128.97 371.647 1122.34C371.647 1116.14 375.836 1111.95 380.811 1111.95C386.964 1111.95 391.545 1117.02 391.545 1127.18C391.545 1140.14 385.96 1145.12 379.938 1145.12C376.491 1145.12 374.047 1143.72 372.258 1141.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.225 1145.12C510.207 1145.12 507.065 1143.02 504.97 1140.75L506.977 1138.14C508.854 1140.1 511.297 1141.8 514.919 1141.8C518.716 1141.8 521.421 1139.53 521.421 1135.87C521.421 1132.03 518.847 1129.45 511.472 1129.45V1126.4C518.061 1126.4 520.33 1123.74 520.33 1120.29C520.33 1117.19 518.236 1115.23 514.919 1115.14C512.345 1115.23 510.076 1116.54 508.287 1118.33L506.148 1115.79C508.548 1113.57 511.385 1111.95 515.094 1111.95C520.461 1111.95 524.388 1114.83 524.388 1119.98C524.388 1123.87 522.076 1126.44 518.672 1127.71V1127.88C522.468 1128.75 525.479 1131.63 525.479 1136C525.479 1141.71 520.897 1145.12 515.225 1145.12ZM540.04 1145.12C533.931 1145.12 530.047 1139.58 530.047 1128.45C530.047 1117.32 533.931 1111.95 540.04 1111.95C546.106 1111.95 549.989 1117.37 549.989 1128.45C549.989 1139.58 546.106 1145.12 540.04 1145.12ZM540.04 1141.93C543.662 1141.93 546.106 1137.87 546.106 1128.45C546.106 1119.11 543.662 1115.18 540.04 1115.18C536.375 1115.18 533.931 1119.11 533.931 1128.45C533.931 1137.87 536.375 1141.93 540.04 1141.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.861 1252.03C193.843 1252.03 190.701 1249.93 188.606 1247.66L190.614 1245.04C192.49 1247.01 194.934 1248.71 198.556 1248.71C202.352 1248.71 205.057 1246.44 205.057 1242.78C205.057 1238.94 202.483 1236.36 195.108 1236.36V1233.31C201.697 1233.31 203.966 1230.64 203.966 1227.2C203.966 1224.1 201.872 1222.14 198.556 1222.05C195.981 1222.14 193.712 1223.44 191.923 1225.23L189.785 1222.7C192.185 1220.48 195.021 1218.86 198.73 1218.86C204.097 1218.86 208.025 1221.74 208.025 1226.89C208.025 1230.78 205.712 1233.35 202.308 1234.62V1234.79C206.105 1235.66 209.116 1238.54 209.116 1242.91C209.116 1248.62 204.534 1252.03 198.861 1252.03ZM215.386 1251.46V1248.14H222.498V1224.27H216.826V1221.74C219.662 1221.22 221.713 1220.48 223.458 1219.47H226.513V1248.14H232.927V1251.46H215.386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.043 1252.03C352.024 1252.03 348.883 1249.93 346.788 1247.66L348.795 1245.04C350.672 1247.01 353.115 1248.71 356.737 1248.71C360.534 1248.71 363.239 1246.44 363.239 1242.78C363.239 1238.94 360.664 1236.36 353.29 1236.36V1233.31C359.879 1233.31 362.148 1230.64 362.148 1227.2C362.148 1224.1 360.054 1222.14 356.737 1222.05C354.163 1222.14 351.894 1223.44 350.104 1225.23L347.966 1222.7C350.366 1220.48 353.203 1218.86 356.912 1218.86C362.279 1218.86 366.206 1221.74 366.206 1226.89C366.206 1230.78 363.894 1233.35 360.49 1234.62V1234.79C364.286 1235.66 367.297 1238.54 367.297 1242.91C367.297 1248.62 362.715 1252.03 357.043 1252.03ZM371.647 1251.46V1249.1C381.684 1240.33 386.309 1233.96 386.309 1228.46C386.309 1224.8 384.389 1222.14 380.418 1222.14C377.8 1222.14 375.531 1223.75 373.785 1225.84L371.473 1223.58C374.091 1220.74 376.84 1218.86 380.898 1218.86C386.614 1218.86 390.193 1222.62 390.193 1228.33C390.193 1234.7 385.174 1241.2 377.669 1248.32C379.327 1248.19 381.291 1248.01 382.905 1248.01H391.764V1251.46H371.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.225 1252.03C510.207 1252.03 507.065 1249.93 504.97 1247.66L506.977 1245.04C508.854 1247.01 511.297 1248.71 514.919 1248.71C518.716 1248.71 521.421 1246.44 521.421 1242.78C521.421 1238.94 518.847 1236.36 511.472 1236.36V1233.31C518.061 1233.31 520.33 1230.64 520.33 1227.2C520.33 1224.1 518.236 1222.14 514.919 1222.05C512.345 1222.14 510.076 1223.44 508.287 1225.23L506.148 1222.7C508.548 1220.48 511.385 1218.86 515.094 1218.86C520.461 1218.86 524.388 1221.74 524.388 1226.89C524.388 1230.78 522.076 1233.35 518.672 1234.62V1234.79C522.468 1235.66 525.479 1238.54 525.479 1242.91C525.479 1248.62 520.897 1252.03 515.225 1252.03ZM539.429 1252.03C534.411 1252.03 531.269 1249.93 529.175 1247.66L531.182 1245.04C533.058 1247.01 535.502 1248.71 539.124 1248.71C542.92 1248.71 545.626 1246.44 545.626 1242.78C545.626 1238.94 543.051 1236.36 535.677 1236.36V1233.31C542.266 1233.31 544.535 1230.64 544.535 1227.2C544.535 1224.1 542.44 1222.14 539.124 1222.05C536.549 1222.14 534.28 1223.44 532.491 1225.23L530.353 1222.7C532.753 1220.48 535.589 1218.86 539.298 1218.86C544.666 1218.86 548.593 1221.74 548.593 1226.89C548.593 1230.78 546.28 1233.35 542.877 1234.62V1234.79C546.673 1235.66 549.684 1238.54 549.684 1242.91C549.684 1248.62 545.102 1252.03 539.429 1252.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.861 1358.94C193.843 1358.94 190.701 1356.84 188.606 1354.57L190.614 1351.95C192.49 1353.92 194.934 1355.62 198.556 1355.62C202.352 1355.62 205.057 1353.35 205.057 1349.69C205.057 1345.85 202.483 1343.27 195.108 1343.27V1340.22C201.697 1340.22 203.966 1337.55 203.966 1334.11C203.966 1331.01 201.872 1329.05 198.556 1328.96C195.981 1329.05 193.712 1330.35 191.923 1332.14L189.785 1329.61C192.185 1327.39 195.021 1325.77 198.73 1325.77C204.097 1325.77 208.025 1328.65 208.025 1333.8C208.025 1337.69 205.712 1340.26 202.308 1341.53V1341.7C206.105 1342.57 209.116 1345.45 209.116 1349.82C209.116 1355.53 204.534 1358.94 198.861 1358.94ZM216.564 1346.37H226.338V1336.55C226.338 1334.98 226.513 1332.41 226.6 1330.75H226.426C225.64 1332.32 224.767 1333.89 223.851 1335.46L216.564 1346.37ZM234.367 1346.37V1349.55H230.135V1358.37H226.338V1349.55H212.418V1346.94L225.727 1326.38H230.135V1346.37H234.367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.043 1358.94C352.024 1358.94 348.883 1356.84 346.788 1354.57L348.795 1351.95C350.672 1353.92 353.115 1355.62 356.737 1355.62C360.534 1355.62 363.239 1353.35 363.239 1349.69C363.239 1345.85 360.664 1343.27 353.29 1343.27V1340.22C359.879 1340.22 362.148 1337.55 362.148 1334.11C362.148 1331.01 360.054 1329.05 356.737 1328.96C354.163 1329.05 351.894 1330.35 350.104 1332.14L347.966 1329.61C350.366 1327.39 353.203 1325.77 356.912 1325.77C362.279 1325.77 366.206 1328.65 366.206 1333.8C366.206 1337.69 363.894 1340.26 360.49 1341.53V1341.7C364.286 1342.57 367.297 1345.45 367.297 1349.82C367.297 1355.53 362.715 1358.94 357.043 1358.94ZM381.116 1358.94C376.142 1358.94 373.087 1356.84 370.949 1354.7L372.913 1352.09C374.745 1353.92 377.058 1355.62 380.767 1355.62C384.52 1355.62 387.574 1352.74 387.574 1348.07C387.574 1343.49 384.956 1340.78 380.942 1340.78C378.804 1340.78 377.451 1341.44 375.618 1342.66L373.48 1341.35L374.484 1326.38H390.062V1329.79H377.974L377.189 1339.04C378.585 1338.25 380.025 1337.77 381.945 1337.77C387.269 1337.77 391.589 1340.91 391.589 1347.94C391.589 1354.97 386.527 1358.94 381.116 1358.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.225 1358.94C510.207 1358.94 507.065 1356.84 504.97 1354.57L506.977 1351.95C508.854 1353.92 511.297 1355.62 514.919 1355.62C518.716 1355.62 521.421 1353.35 521.421 1349.69C521.421 1345.85 518.847 1343.27 511.472 1343.27V1340.22C518.061 1340.22 520.33 1337.55 520.33 1334.11C520.33 1331.01 518.236 1329.05 514.919 1328.96C512.345 1329.05 510.076 1330.35 508.287 1332.14L506.148 1329.61C508.548 1327.39 511.385 1325.77 515.094 1325.77C520.461 1325.77 524.388 1328.65 524.388 1333.8C524.388 1337.69 522.076 1340.26 518.672 1341.53V1341.7C522.468 1342.57 525.479 1345.45 525.479 1349.82C525.479 1355.53 520.897 1358.94 515.225 1358.94ZM541.044 1355.84C544.098 1355.84 546.455 1352.91 546.455 1348.55C546.455 1344.23 544.578 1341.48 540.695 1341.48C538.687 1341.48 536.244 1342.62 534.149 1345.58C534.629 1352.22 537.029 1355.84 541.044 1355.84ZM549.64 1329.05L547.458 1331.53C546.193 1330.01 544.273 1329.09 542.309 1329.09C537.946 1329.09 534.237 1332.45 534.062 1342.4C536.026 1340 538.818 1338.51 541.349 1338.51C546.76 1338.51 550.207 1341.87 550.207 1348.55C550.207 1354.75 546.018 1358.94 541.044 1358.94C534.891 1358.94 530.353 1353.66 530.353 1343.1C530.353 1330.57 535.982 1325.77 542.178 1325.77C545.495 1325.77 547.895 1327.17 549.64 1329.05Z",
    fill: "white"
  }))), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M634.708 233.374V230.058H641.821V206.189H636.148V203.658C638.984 203.134 641.035 202.392 642.781 201.388H645.835V230.058H652.25V233.374H634.708ZM657.08 222.683V219.629H668.251V222.683H657.08ZM674.041 233.374V230.058H681.153V206.189H675.481V203.658C678.317 203.134 680.368 202.392 682.113 201.388H685.168V230.058H691.583V233.374H674.041ZM706.58 233.942C700.689 233.942 696.369 230.363 696.369 225.432C696.369 221.156 699.336 218.189 702.26 216.618V216.4C699.904 214.785 697.94 212.385 697.94 209.025C697.94 204.138 701.693 200.908 706.711 200.908C712.165 200.908 715.482 204.399 715.482 209.33C715.482 212.69 713.125 215.57 711.205 217.054V217.272C713.998 218.887 716.616 221.287 716.616 225.651C716.616 230.32 712.602 233.942 706.58 233.942ZM708.762 216.007C710.944 214.087 712.078 211.905 712.078 209.549C712.078 206.407 710.071 203.832 706.624 203.832C703.7 203.832 701.562 205.927 701.562 209.025C701.562 212.865 705.009 214.523 708.762 216.007ZM706.667 230.974C710.333 230.974 712.82 228.749 712.82 225.563C712.82 221.287 708.893 219.672 704.354 217.84C701.78 219.498 699.991 222.029 699.991 225.083C699.991 228.487 702.827 230.974 706.667 230.974Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M622.01 1301.37V1298.06H629.123V1274.19H623.45V1271.66C626.287 1271.13 628.338 1270.39 630.083 1269.39H633.138V1298.06H639.552V1301.37H622.01ZM653.764 1286.28C655.903 1286.28 658.303 1285.05 660.441 1282C660.004 1275.41 657.561 1271.92 653.459 1271.92C650.404 1271.92 648.048 1274.8 648.048 1279.16C648.048 1283.48 649.968 1286.28 653.764 1286.28ZM644.906 1298.67L647.088 1296.18C648.441 1297.71 650.404 1298.63 652.455 1298.63C656.601 1298.63 660.179 1295.22 660.484 1285.27C658.564 1287.67 655.815 1289.24 653.11 1289.24C647.786 1289.24 644.295 1285.8 644.295 1279.16C644.295 1272.97 648.484 1268.78 653.459 1268.78C659.612 1268.78 664.194 1273.84 664.194 1284.01C664.194 1296.97 658.608 1301.94 652.586 1301.94C649.139 1301.94 646.695 1300.55 644.906 1298.67ZM668.587 1290.68V1287.63H679.758V1290.68H668.587ZM693.228 1301.94C688.21 1301.94 685.068 1299.85 682.973 1297.58L684.981 1294.96C686.857 1296.92 689.301 1298.63 692.923 1298.63C696.719 1298.63 699.425 1296.36 699.425 1292.69C699.425 1288.85 696.85 1286.28 689.475 1286.28V1283.22C696.065 1283.22 698.334 1280.56 698.334 1277.11C698.334 1274.01 696.239 1272.05 692.923 1271.96C690.348 1272.05 688.079 1273.36 686.29 1275.15L684.152 1272.62C686.552 1270.39 689.388 1268.78 693.097 1268.78C698.465 1268.78 702.392 1271.66 702.392 1276.81C702.392 1280.69 700.079 1283.26 696.675 1284.53V1284.71C700.472 1285.58 703.483 1288.46 703.483 1292.82C703.483 1298.54 698.901 1301.94 693.228 1301.94ZM719.047 1298.84C722.102 1298.84 724.458 1295.92 724.458 1291.56C724.458 1287.24 722.582 1284.49 718.698 1284.49C716.691 1284.49 714.247 1285.62 712.153 1288.59C712.633 1295.22 715.033 1298.84 719.047 1298.84ZM727.644 1272.05L725.462 1274.54C724.197 1273.01 722.277 1272.09 720.313 1272.09C715.949 1272.09 712.24 1275.45 712.066 1285.4C714.029 1283 716.822 1281.52 719.353 1281.52C724.764 1281.52 728.211 1284.88 728.211 1291.56C728.211 1297.75 724.022 1301.94 719.047 1301.94C712.895 1301.94 708.356 1296.66 708.356 1286.1C708.356 1273.58 713.986 1268.78 720.182 1268.78C723.498 1268.78 725.898 1270.17 727.644 1272.05Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_334_179414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 474.662,
    height: 1282.91,
    fill: "white",
    transform: "translate(132.455 110.369)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoulVertBetarea1);
export default __webpack_public_path__ + "static/media/roul_vert_betarea1.d8f00bb08209f4ece10cfb7e8119312a.svg";
export { ForwardRef as ReactComponent };